
<template>
  <div class="customer-container">
    <el-card>
      <template #header>
        <div class="flex justify-between items-center">
          <div class="flex items-center">
            <el-button type="primary" @click="showAddDialog">新增客户</el-button>
            <el-upload
              :show-file-list="false"
              :before-upload="handleImport"
              accept=".xlsx, .xls"
              style="display: inline-block; margin-left: 10px;">
              <el-button type="success">批量导入客户</el-button>
            </el-upload>
          </div>
          <div>
            <el-button type="default" @click="downloadTemplate">
              下载批量上传客户模板
            </el-button>
          </div>
        </div>
      </template>

      <!-- 筛选区域 -->
      <div class="filter-container">
        <el-input
          v-model="filters.name"
          placeholder="客户名称"
          clearable
          style="width: 180px; margin-right: 10px;"
        />
        <el-input
          v-model="filters.tin"
          placeholder="纳税人识别码"
          clearable
          style="width: 180px; margin-right: 10px;"
        />
        <el-input
          v-model="filters.contactPerson"
          placeholder="联系人"
          clearable
          style="width: 180px; margin-right: 10px;"
        />
        <el-input
          v-model="filters.contactInfo"
          placeholder="联系方式"
          clearable
          style="width: 180px; margin-right: 10px;"
        />
        <el-select
          v-model="filters.status"
          placeholder="状态"
          clearable
          style="width: 120px; margin-right: 10px;"
        >
          <el-option label="已合作" value="Cooperated"></el-option>
          <el-option label="未合作" value="Uncooperated"></el-option>
          <el-option label="在黑名单" value="Blacklist"></el-option>
        </el-select>
        <el-input
          v-model="filters.userName"
          placeholder="管理负责人姓名"
          clearable
          style="width: 150px;"
        />
      </div>

      <el-table :data="filteredCustomers" style="width: 100%">
        <el-table-column prop="name" label="客户名称"></el-table-column>
        <el-table-column min-width="154px;" prop="tin" label="纳税人识别码"></el-table-column>
        <el-table-column prop="contactPerson" label="联系人"></el-table-column>
        <el-table-column prop="contactInfo" label="联系方式"></el-table-column>
        <el-table-column prop="status" label="状态" :formatter="formatCoustomerStatus"></el-table-column>
        <el-table-column prop="account" label="客户余额"></el-table-column> 
        <el-table-column prop="user.username" label="管理负责人"></el-table-column>
        <el-table-column prop="createTime" label="注册时间"></el-table-column>
        <el-table-column label="操作" width="180">
          <template #default="scope">
            <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog :title="dialogTitle" v-model="dialogVisible" width="50%">
      <el-form :model="currentCustomer" :rules="rules" ref="customerForm" label-width="120px">
        <el-form-item label="客户名称" prop="name">
          <el-input v-model="currentCustomer.name"></el-input>
        </el-form-item>
        <el-form-item label="纳税人识别码" prop="tin">
          <el-input v-model="currentCustomer.tin"></el-input>
        </el-form-item>
        <el-form-item label="联系人" prop="contactPerson">
          <el-input v-model="currentCustomer.contactPerson"></el-input>
        </el-form-item>
        <el-form-item label="联系方式" prop="contactInfo">
          <el-input v-model="currentCustomer.contactInfo"></el-input>
        </el-form-item>
        <el-form-item prop="status" label="当前状态">
          <el-select v-model="currentCustomer.status" placeholder="请选择订单类型" style="width: 100%">
            <el-option label="已合作" value="Cooperated" ></el-option>
            <el-option label="未合作" value="Uncooperated"></el-option>
            <el-option label="在黑名单" value="Blacklist"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="默认采购费率%" prop="rate">
          <el-input-number v-model="currentCustomer.purchaseRate" :min="0" :precision="6" :step="0.1" style="width: 100%"></el-input-number>
        </el-form-item> -->
         <el-form-item label="负责人" prop="user" v-if="isAdmin">
          <el-select v-model="currentCustomer.user" placeholder="请选择负责人" style="width: 100%" value-key="id" filterable>
            <el-option
              v-for="user in operators"
              :key="user.id"
              :label="user.username"
              :value="user">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm">确认</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ref, computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import { ElMessage, ElMessageBox } from 'element-plus'
import { UserStatus } from '@/store'

export default {
  setup() {
    const user = computed(() => store.state.user)
    const isAdmin = computed(() => user.value?.role === 'ADMIN')
    const store = useStore()
    const dialogVisible = ref(false)
    const dialogTitle = ref('')
    
    // 筛选条件
    const filters = ref({
      name: '',
      tin: '',
      account: 0,
      contactPerson: '',
      contactInfo: '',
      status: '',
      userName: ''
    })

    const downloadTemplate = () => {
      // 创建一个虚拟的a标签用于下载
      const link = document.createElement('a');
      // 由于当前没有xlsx格式模板，使用CSV格式模板作为备选
      link.href = '/客户导入事例模版.xlsx';
      // 设置文件名
      link.download = '客户导入事例模版.xlsx';
      // 模拟点击下载
      document.body.appendChild(link);
      link.click();
      // 移除虚拟元素
      document.body.removeChild(link);
    }

    const currentCustomer = ref({
      id: null,
      name: '',
      tin: '',
      contactPerson: '',
      company: '',
      status: '',
      purchaseRate: 0,
      user: null
    })

    const rules = {
      name: [{ required: true, message: '请输入客户名称', trigger: 'blur' }],
      // contactPerson: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
      // company: [{ required: true, message: '请输入工作单位', trigger: 'blur' }],
      status: [{ required: true, message: '请选择当前状态', trigger: 'change' }]
    }

    const customers = computed(() => {
      // 管理员可以看到所有客户
      if (user.value?.role === 'ADMIN') {
        return store.state.customers;
      }
      // 经理可以看到同部门的所有客户
      if (user.value?.role === 'MANAGER') {
        return store.state.customers.filter(customer => 
          (customer.departmentId === user.value.departmentId ||customer.user.id === user.value?.id)
        );
      }
      // 主管可以看到同部门同团队的所有客户
      if (user.value?.role === 'SUPERVISOR') {
        return store.state.customers.filter(customer => 
          ((customer.departmentId === user.value.departmentId && 
          customer.teamId === user.value.teamId) ||
          customer.user.id === user.value?.id)
        );
      }
      // 普通用户只能看到自己的客户
      return store.state.customers.filter(customer => customer.user.id === user.value?.id);
    })
    
    // 根据筛选条件过滤客户列表
    const filteredCustomers = computed(() => {
      return customers.value.filter(customer => {
        // 客户名称筛选
        if (filters.value.name && !customer.name.toLowerCase().includes(filters.value.name.toLowerCase())) {
          return false
        }
        // 纳税人识别码筛选
        if (filters.value.tin && !customer.tin.toLowerCase().includes(filters.value.tin.toLowerCase())) {
          return false
        }
        // 联系人筛选
        if (filters.value.contactPerson && !customer.contactPerson.toLowerCase().includes(filters.value.contactPerson.toLowerCase())) {
          return false
        }
        // 联系方式筛选
        if (filters.value.contactInfo && !customer.contactInfo.toLowerCase().includes(filters.value.contactInfo.toLowerCase())) {
          return false
        }
        // 状态筛选
        if (filters.value.status && customer.status !== filters.value.status) {
          return false
        }
        // 管理负责人筛选（模糊匹配）
        if (filters.value.userName && (!customer.user || !customer.user.username.toLowerCase().includes(filters.value.userName.toLowerCase()))) {
          return false
        }
        return true
      })
    })
   
    const operators =computed(() => {
      return store.state.users.filter(user => 
        user.status === UserStatus.APPROVED.value
      )
    })

    onMounted(() => {
      store.dispatch('fetchCustomers')
      if (isAdmin.value) {
        store.dispatch('fetchUsers')
      }
    })

    const showAddDialog = () => {
      dialogTitle.value = '新增客户'
      currentCustomer.value = {
        id: null,
        name: '',
        tin: '',
        contactPerson: '',
        contactInfo: '',
        status: '',
        purchaseRate: 0,
        user: null,
        userId: null
      }
      dialogVisible.value = true
    }

    const handleEdit = (customer) => {
      dialogTitle.value = '编辑客户'
      // console.log("customer.user:", customer.user)
      currentCustomer.value = { ...customer  }
      dialogVisible.value = true
    }

    const handleDelete = (id) => {
      ElMessageBox.confirm('确认删除该客户吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        store.dispatch('deleteCustomer', id)
        .then(() => {
          ElMessage.success('删除成功')
          store.dispatch('fetchCustomers')
        })
        .catch (error => {
          ElMessage.error('删除失败: ' + (error.response?.data?.message || error.message))
        })
      }).catch(() => {})
    }

    const submitForm = () => {
      if (currentCustomer.value.id) {
        store.dispatch('updateCustomer', {...currentCustomer.value, userId: currentCustomer.value.user?.id})
        .then(res=>{
          if(res){
            ElMessage.success('更新成功')
          }
        }).catch(error => {
          ElMessage.error('更新失败:'+(error.response?.data?.message || error.message))
        })
      } else {
        store.dispatch('createCustomer', {...currentCustomer.value, userId: currentCustomer.value.user?.id})
        .then(res=>{
          if(res.status === 200){
            ElMessage.success('新增成功')
          }else if(res.code === 5001){
            ElMessage.error('新增失败:客户名称已存在')
          }
        })
      }
      dialogVisible.value = false
    }

    const formatCoustomerStatus = (row, column) => {
      switch (row.status) {
        case 'Cooperated':
          return '已合作'
        case 'Uncooperated':
          return '未合作'
        case 'Blacklist':
          return '在黑名单'
        default:
          return '未知状态'
      }
    }

    const handleImport = async (file) => {
      try {
        await store.dispatch('importCustomers', file);
        ElMessage.success('导入成功');
        return false; // 阻止自动上传
      } catch (error) {
        // console.log("导入客户失败error:",error.response)
        if(error.response?.data.code === 5002){
          ElMessage.error('导入失败: 有客户名称已存在')
        }else{
          ElMessage.error('导入失败11: ' + (error.response?.data?.message || error.message));
        }
        return false;
      }
    }

    return {
      customers,
      filteredCustomers,
      filters,
      operators,
      isAdmin,
      dialogVisible,
      dialogTitle,
      currentCustomer,
      rules,
      formatCoustomerStatus,
      showAddDialog,
      handleEdit,
      handleDelete,
      submitForm,
      handleImport,
      downloadTemplate
    }
  }
}
</script>

<style scoped>
.customer-container {
  padding: 20px;
}

.flex {
  display: flex;
}

.items-center {
  align-items: center;
}
</style>
